import React, { useEffect, useState } from 'react';

import { Outlet, Navigate, useLocation } from 'react-router-dom';

import { AppRoutes } from 'routes/routes.enums';
import { ApplicationEnvironments } from 'enums/common.enums';
import { useAppDispatch } from 'hooks/useAppDispatch';
import Loader from 'components/Loader/index';
import {
  getCredentialsFromStorage,
  removeCredentialsFromStorage,
} from 'pages/PasswordProtection/passwordProtection.utils';
import { passwordProtectionApi } from 'api/PasswordProtectionApi';

export const PasswordProtectedRoute = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const [hasAccess, setHasAccess] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkPassword = async () => {
      try {
        setIsLoading(true);

        const credentials = getCredentialsFromStorage();

        if (credentials) {
          const response = await passwordProtectionApi.check({
            userName: credentials.userName,
            password: credentials.password,
          });

          setHasAccess(response.hasAccess);
        } else {
          setHasAccess(false);
          removeCredentialsFromStorage();
        }
      } finally {
        setIsLoading(false);
      }
    };

    if (process.env.REACT_APP_ENVIRONMENT === ApplicationEnvironments.Testing) {
      checkPassword();
    } else {
      setHasAccess(true);
      setIsLoading(false);
    }
  }, [dispatch, setHasAccess]);

  if (isLoading) {
    return <Loader />;
  }

  if (!hasAccess) {
    return <Navigate to={AppRoutes.PasswordProtection} replace state={{ from: location }} />;
  }

  return <Outlet />;
};
